export type QueryValue = string | number | boolean | null | undefined | ReadonlyArray<string | number | boolean>;

// Builds a URL query string from an object. null/undefined values are skipped;
// array values become repeated keys (e.g. { status: ['a','b'] } -> "status=a&status=b").
// Non-string scalars are coerced with String().
export function toQueryString(params: Record<string, QueryValue>): string {
    const search = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null) continue;
        if (Array.isArray(value)) {
            value.forEach((v) => search.append(key, String(v)));
        } else {
            search.append(key, String(value));
        }
    }
    return search.toString();
}

// Parses a URL query string into an object. Repeated keys become arrays
// (e.g. "status=a&status=b" -> { status: ['a','b'] }); single keys stay as strings.
export function fromQueryString(search: string): Record<string, string | string[]> {
    const params = new URLSearchParams(search);
    const result: Record<string, string | string[]> = {};
    for (const key of Array.from(new Set(params.keys()))) {
        const values = params.getAll(key);
        result[key] = values.length === 1 ? values[0] : values;
    }
    return result;
}
